import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { S1Table, S1ButtonType, S1UIService } from '@app/s1';
import { StazioneComponent } from '../stazione/stazione.component';
import { IStazione, IStazioneTratta } from '@app/shared/models/stazione';
import { StazioneService, IRicercaStazioneParams } from '@app/shared/services/stazione.service';
import { AssociaStazioneModalComponent } from '../associa-stazione-modal/associa-stazione-modal.component';
import { IDisassociaStazioneParams, IRicercaStazioneTrattaParams, TrattaService } from '@app/shared/services/tratta.service';

@Component({
  selector: 'ser-stazioni',
  templateUrl: './stazioni.component.html',
  styleUrl: './stazioni.component.scss'
})
export class StazioniComponent {

  @Input() set idTratta(newValue: string) {
    this._idTratta = newValue;
    if (this._idTratta) {
      this.search();
    }
  }

  @Input() fromModal: boolean = false;

  @Output() elementToLink = new EventEmitter<IStazione>();

  @ViewChild('stazioneModal') stazioneModal: StazioneComponent;
  @ViewChild('associaModal') associaModal: AssociaStazioneModalComponent;
  @ViewChild('table') table: S1Table<IStazioneTratta>;

  s1ButtonType = S1ButtonType;

  searchForm: UntypedFormGroup;

  _idTratta: string;

  constructor (
    private formBuilder: UntypedFormBuilder,
    private stazioneService: StazioneService,
    private trattaService: TrattaService,
    private ui: S1UIService) {

    this.searchForm = this.formBuilder.group({
      'codice': [null, null],
      'descrizione': [null, null],
      'inGestione': [true, null]
    });

  }

  ngAfterViewInit(): void { 
    this.search();
  }

  search() {

    if (!this.table) {
      return;
    }

    if (this._idTratta) {

      const params: IRicercaStazioneTrattaParams = {
        page: this.table?.config.pagination.page.page,
        pageSize: +this.table?.config.pagination.page.itemsPerPage,
        sortBy: this.table?.sortBy() ?? "descrizione",
        codice: this.searchForm.controls.codice.value,
        descrizione: this.searchForm.controls.descrizione.value,
        id: this._idTratta
      }

      this.trattaService.ricercaStazione(params).subscribe(stazioniPaginate => {
        this.table.updateData(stazioniPaginate.elements, stazioniPaginate.paginationInfo)
      })

    } else {

      let params: IRicercaStazioneParams = {
        page: this.table?.config.pagination.page.page,
        pageSize: +this.table?.config.pagination.page.itemsPerPage,
        sortBy: this.table?.sortBy() ?? "descrizione",
        codice: this.searchForm.controls.codice.value,
        descrizione: this.searchForm.controls.descrizione.value,
        inGestione: this.searchForm.controls.inGestione.value
      }
  
      this.stazioneService.ricerca(params).subscribe(stazioniPaginate => {
        this.table.updateData(stazioniPaginate.elements, stazioniPaginate.paginationInfo)
      })

    }

  }

  goToNew() {
    this.stazioneModal.open();
  }

  goToDetail(stazione: IStazione | IStazioneTratta = null) {
    this.stazioneModal.open(this._idTratta ? (stazione as IStazioneTratta).idStazione : stazione.id);
  }

  askDelete(stazione: IStazione) {

    this.ui.showDialogPopup("stazioni.messages.delete").then(result => {
      if (result.value) {
        this.delete(stazione)
      }
    })

  }

  private delete(stazioneToDelete: IStazione) {

    this.stazioneService.elimina(stazioneToDelete?.id).subscribe(deleted => {

      if (deleted) {
        this.ui.showSuccessToast("stazioni.messages.deleted")
        this.table?.refreshAfterDelete()
      }

    })

  }

  openAssocia() {

    this.associaModal.open(this._idTratta);

  }

  askDissasocia(stazione: IStazioneTratta) {

    this.ui.showDialogPopup("stazioni.messages.unlink").then(result => {
      if (result.value) {
        this.disassocia(stazione)
      }
    })

  }

  private disassocia(stazioneToUnlink: IStazioneTratta) {

    const params: IDisassociaStazioneParams = {
      idTratta: this._idTratta,
      idStazione: stazioneToUnlink.idStazione
    }

    this.trattaService.disassociaStazione(params).subscribe(success => {
      if (success) {
        this.ui.showSuccessToast("stazioni.messages.unlinked");
        this.search();
      }
      
    })

  }

  associa(stazione: IStazione) {
    this.elementToLink.emit(stazione);
  }

}
